import type { TicketDetail } from '@easyhelp/shared';
import Alert from '@mui/material/Alert';
import { DetailSection, FactList } from './DetailSection';
import { declaredContactsNotice } from './notices';

/**
 * Chi ha segnalato e i recapiti. Sul canale autenticato l'email viene dall'account (verificata);
 * sul pre-accesso email, telefono e struttura sono **dichiarati e non verificati**.
 */
export function TicketReporterSection({ ticket }: { ticket: Pick<TicketDetail, 'reporter' | 'channel'> }) {
  const { reporter } = ticket;
  const declared = !reporter.emailVerified;
  const qualifier = declared ? 'dichiarato, non verificato' : "dall'account, verificato";
  return (
    <DetailSection title="Segnalante e recapiti">
      {declared && (
        <Alert severity="warning" role="note" sx={{ overflowWrap: 'anywhere' }}>
          {declaredContactsNotice(reporter.phone)}
        </Alert>
      )}
      <FactList
        facts={[
          { label: 'Email', value: `${reporter.email} · ${qualifier}` },
          ...(ticket.channel === 'pre-accesso'
            ? [
                { label: 'Telefono', value: reporter.phone && `${reporter.phone} · dichiarato` },
                { label: 'Struttura', value: reporter.structure && `${reporter.structure} · dichiarata` },
              ]
            : [
                { label: 'Ruolo', value: reporter.role },
                { label: 'Unità operativa', value: reporter.unit },
              ]),
        ]}
      />
    </DetailSection>
  );
}
